<template>
  <div class="detail-page-skeleton">
    <div v-for="item in normalizedCount" :key="item" class="section-card">
      <v-skeleton-loader :type="type" style="border-radius: 18px; background:transparent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    count?: number;
    type?: string;
  }>(),
  {
    count: 2,
    type: "heading, subtitle, paragraph",
  },
);

const normalizedCount = computed(() => Math.max(1, Number(props.count) || 1));
</script>

<style scoped>
.detail-page-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-card {
  background: #fff;
  border-radius: 18px;
}
</style>
